export default __webpack_public_path__ + "static/media/pixelBackground.07f58ad4.jpg";